var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#5693F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM14.25 9.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12a7 7 0 1 0-10.55 6.021l.007.078a.997.997 0 0 0 .995.901h5.095a.996.996 0 0 0 .995-.9l.008-.079a6.982 6.982 0 0 0 3.45-6.02zm-7-6a5.995 5.995 0 0 1 5.985 5.699L15.382 13H8.618L6.015 11.7A5.995 5.995 0 0 1 12 6zM6.06 12.84l1.97.985.29 2.905a5.985 5.985 0 0 1-2.26-3.89zM14.547 18H9.453l-.4-4h5.895l-.4 4zm1.133-1.27.29-2.906 1.97-.985a5.985 5.985 0 0 1-2.26 3.89z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientActiveIcon);
export default __webpack_public_path__ + "static/media/patientActiveIcon.db3a015e6946a488b757bfdf7f6d072c.svg";
export { ForwardRef as ReactComponent };